import { RequestPresignedUrlRequestSchema, RequestPresignedUrlResponseSchema, ConfirmUploadRequestSchema, ConfirmUploadResponseSchema } from './upload-avatar.schema';
/**
 * Request Presigned URL Endpoint Contract
 * Generates a presigned URL for direct upload to DigitalOcean Spaces
 */ export const requestPresignedUrlContract = {
    method: 'POST',
    path: '/api/v2/upload-avatar/request-url',
    description: 'Request a presigned URL for avatar upload',
    requestSchema: RequestPresignedUrlRequestSchema,
    responseSchema: RequestPresignedUrlResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request',
            401: 'Unauthorized - invalid or missing token',
            500: 'Internal server error'
        }
    }
};
/**
 * Confirm Upload Endpoint Contract
 * Processes uploaded avatar and updates user profile
 */ export const confirmUploadContract = {
    method: 'POST',
    path: '/api/v2/upload-avatar/confirm',
    description: 'Confirm avatar upload and process image',
    requestSchema: ConfirmUploadRequestSchema,
    responseSchema: ConfirmUploadResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request or invalid image',
            401: 'Unauthorized - invalid or missing token',
            404: 'User not found',
            500: 'Internal server error'
        }
    }
};

//# sourceMappingURL=upload-avatar.contract.js.map